import { useMemo, useState } from 'react';

import { Bonus } from '../lib/bonus';
import { Reaction } from '../lib/reaction';
import { ReactionTab, ReactionTabType } from '../lib/reaction-tab';
import { useBonusReactions } from './use-bonus-reactions';

export const useReactionTabs = (bonus: Bonus) => {
	const { data: reactions, isLoading } = useBonusReactions(bonus);
	const [tabIndex, setTabIndex] = useState(0);

	const tabs = useMemo(() => {
		if (!reactions?.length) {
			return [];
		}

		const reactionMap = new Map<ReactionTabType, ReactionTab>();

		reactionMap.set('all', new ReactionTab());

		reactions?.forEach((bonusReaction) => {
			reactionMap.get('all')?.add(bonusReaction);

			const reaction = Reaction.fromShortcode(bonusReaction.emoji);

			if (!reactionMap.has(reaction.type)) {
				reactionMap.set(reaction.type, new ReactionTab(reaction.type));
			}

			reactionMap.get(reaction.type)?.add(bonusReaction);
		});

		const tabsArray = [...reactionMap.values()];

		// If the length is 2 then the only tabs are the "all" tab and a single reaction. In that case we only
		// need to show the single reaction tab since both contain the exact same information.
		if (tabsArray.length === 2) {
			tabsArray.shift();
		}

		return tabsArray;
	}, [reactions]);

	return { isLoading, onSelectTab: setTabIndex, selectedTab: tabIndex, tabs };
};
